import { Type } from '@angular/core';
import { BusinessProcessStartListComponent } from '../Views/Runtime/instance/businessProcessStartList.component';
import { GroupListComponent } from '../Views/Admin/groups/group-list.component';
import { UserListComponent } from '../Views/Admin/users/user-list.component';
import { LdapComponent } from '../Views/Admin/ldap/ldap.component';
import { UserSecurityConfigComponent } from '../Views/Admin/security-configuration/userSecurityConfig.component';
import { ProfileListComponent } from '../Views/Admin/profiles/profile-list.component';
import { AccessControlComponent } from '../Views/Admin/access-control/access-control.component';
import { BusinessProcessListComponent } from '../Views/Runtime/business-process/business-process-list.component';
import { BusinessProcessInstanceHistoryComponent } from '../Views/Runtime/reports/business-process-instance-history/business-process-instance-history.component';
import { BusinessProcessInstanceOverrideComponent } from '../Views/Runtime/administration/business-process-instance-override/business-process-instance-override.component';
import { InstanceHistoryStateLifeCycleComponent } from '../Views/Runtime/reports/instance-history-stateLifeCycle/instance-history-stateLifeCycle.component';
import { TimingAnalysisReportComponent } from '../Views/Runtime/reports/timing-analysis-report/timing-analysis-report.component';
import { ServiceConfigurationListComponent } from '../Views/Configuration/service-configuration-list/service-configuration-list.component';
import { InstanceOverrideReportComponent } from '../Views/Runtime/reports/instance-override-report/instance-override-report.component';
import { BusinessProcessInvokeListComponent } from '../Views/HumanInteraction/business-process-invoke-list/business-process-invoke-list.component';
import { CustomInteractionQueueComponent } from '../Views/HumanInteraction/custom-interaction-queue/custom-interaction-queue.component';
import { BusinessProcessSuspendedListComponent } from '../Views/HumanInteraction/business-process-suspended-list/business-process-suspended-list.component';
import { SequentialAllocationComponent } from '../Views/HumanInteraction/sequential-allocation/sequential-allocation.component';
import {InteractionQueueConfigComponent} from '../Views/Configuration/interaction-queue-config/interaction-queue-config.component';
import {CustomInteractionQueueConfigListComponent} from '../Views/Configuration/custom-interaction-queue-config-list/custom-interaction-queue-config-list.component';
import {GlobalVariablesComponent} from '../Views/Configuration/global-variables/global-variables.component';
import {DriverUpdateListComponent} from '../Views/Configuration/driver-update-list/driver-update-list.component';
import {GlobalVariableGroupsComponent} from '../Views/Configuration/global-variable-groups/global-variable-groups.component';
import {MetadataStructureListComponent} from '../Views/Configuration/metadata-structure-list/metadata-structure-list.component';
import {UserMetadataAdminComponent} from '../Views/Configuration/user-metadata-admin/user-metadata-admin.component';
import {DistributionCustomInteractionComponent} from '../Views/Configuration/distribution-custom-interaction/distribution-custom-interaction.component';
import {PoolsComponent} from '../Views/Configuration/pools/pools.component';
import {SystemFlowComponent} from '../Views/Configuration/system-flow/system-flow.component';
import {BusinessProcessQueueManagerComponent} from '../Views/Runtime/administration/business-process-queue-manager/business-process-queue-manager.component';
import {BatchManagementComponent} from '../Views/Batch/management/batch-management.component';
import {TemplateConfigurationComponent} from '../Views/Batch/template-configuration/template-configuration.component';
import {DataExtractionLayoutComponent} from '../Views/Configuration/data-extraction-layout/data-extraction-layout.component';
import {SchedulingComponent} from '../Views/Configuration/scheduling/scheduling.component';
import {TaskMonitoringComponent} from '../Views/Configuration/task-monitoring/task-monitoring.component';
import {ReviewInstancesComponent} from '../Views/HumanInteraction/review-instances/review-instances.component';

export enum LinkType {
  fromNavMenu = 0,
  fromPage = 1
}

export const menuComponentFromTo: MenuModelFromTo[] = [
  {
    urlMenu: '/Runtime/BusinessProcessStartList.aspx',
    routeMenu: 'instance',
    componentMenu: BusinessProcessStartListComponent
  },
  {
    urlMenu: '/Admin/AccessControl/LdapV2.aspx',
    routeMenu: 'ldap',
    componentMenu: LdapComponent
  },
  {
    urlMenu: '/Admin/AccessControl/GroupList.aspx',
    routeMenu: 'groups',
    componentMenu: GroupListComponent
  },
  {
    urlMenu: '/Admin/AccessControl/UserList.aspx',
    routeMenu: 'userList',
    componentMenu: UserListComponent
  },
  {
    urlMenu: '/Configuration/UserSecurityConfiguration.aspx',
    routeMenu: 'userSecurityConfig',
    componentMenu: UserSecurityConfigComponent
  },
  {
    urlMenu: '/Admin/AccessControl/ProfileList.aspx',
    routeMenu: 'profileList',
    componentMenu: ProfileListComponent
  },
  {
    urlMenu: '/BusinessProcessAccessControl.aspx',
    routeMenu: 'extractionAccessControl',
    componentMenu: AccessControlComponent,
    title: 'Controle de Acesso de Extração'
  },
  {
    urlMenu: '/StateAccessControl.aspx',
    routeMenu: 'stateAccessControl',
    componentMenu: AccessControlComponent,
    title: 'Controle de Acesso de Estado(s)'
  },
  {
    urlMenu: '/BusinessProcessList.aspx',
    routeMenu: 'businessProcessList',
    componentMenu: BusinessProcessListComponent
  },
  {
    urlMenu: '/Reports/Runtime/BusinessProcessInstanceHistoryReport.aspx',
    routeMenu: 'Reports/BusinessProcessInstanceHistoryReport',
    componentMenu: BusinessProcessInstanceHistoryComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Reports/Runtime/BusinessProcessInstancesReport.aspx',
    routeMenu: 'Reports/InstanceHistoryStateLifeCycle',
    componentMenu: InstanceHistoryStateLifeCycleComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Runtime/BusinessProcessInstanceOverrideV2.aspx',
    routeMenu: 'businessProcessInstanceOverride',
    componentMenu: BusinessProcessInstanceOverrideComponent,
    title: 'Imposição de Instâncias'
  },
  {
    routeMenu: 'historyReportVisibilityComponent',
    title: 'Configurar Visibilidade de Campos e Estados para o Histórico de Execução',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'relatedBusinessProcessConfiguration',
    title: 'Configurar Buscas por Instâncias Relacionadas',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'manageLockedElements',
    title: 'Elementos Bloqueados',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'businessProcessRecoverVersion',
    title: 'Recuperar Versões Anteriores',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'state',
    title: 'Editar Estado',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'newState',
    title: 'Cadastrar Estado',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'businessProcess',
    title: 'Editar Processo de Negócio',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'newBusinessProcess',
    title: 'Cadastrar Processo de Negócio',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'fieldsManagement',
    title: 'Edição Múltipla de Campos',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'instanceHistoryDetails',
    title: 'Histórico de Execução da Instância',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'customInstanceView',
    title: 'Visualização da Instância através de um layout',
    linkType: LinkType.fromPage
  },
  {
    urlMenu: '/Reports/Runtime/BusinessProcessInstanceOverrideReport.aspx',
    routeMenu: 'Reports/InstanceOverrideReport',
    componentMenu: InstanceOverrideReportComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Reports/Runtime/TimingAnalysisReport.aspx',
    routeMenu: 'timingAnalysisReport',
    componentMenu: TimingAnalysisReportComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Runtime/BusinessProcessInvokeList.aspx',
    routeMenu: 'businessProcessInvokeList',
    componentMenu: BusinessProcessInvokeListComponent,
    title: 'Fila de Instâncias'
  },
  {
    urlMenu: '/Configuration/WorkflowConfiguration.aspx',
    routeMenu: 'serviceConfigurationList',
    componentMenu:  ServiceConfigurationListComponent,
    title: 'Configuração de Componentes do Sistema'
  },
  {
    urlMenu: '/Runtime/CustomInteractionQueue.aspx',
    routeMenu: 'customInteractionQueue',
    componentMenu: CustomInteractionQueueComponent
  },
  {
    urlMenu: '/Runtime/BusinessProcessSuspendedList.aspx',
    routeMenu: 'instanceSuspendedList',
    componentMenu: BusinessProcessSuspendedListComponent,
    title: 'Fila de Instâncias Adiadas',
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Runtime/CustomInteractionQueueSuspendedList.aspx',
    routeMenu: 'instanceSuspendedList',
    componentMenu: BusinessProcessSuspendedListComponent,
    title: 'Fila de Instâncias Adiadas',
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Runtime/SequentialAllocation.aspx',
    routeMenu: 'sequentialAllocation',
    componentMenu: SequentialAllocationComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Review/Reviewinstances.aspx',
    routeMenu: 'reviewInstances',
    componentMenu: ReviewInstancesComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Runtime/CustomInteractionQueueSequencialAllocation.aspx',
    routeMenu: 'sequentialAllocation',
    componentMenu: SequentialAllocationComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/HumanInteractionQueueConfiguration.aspx',
    routeMenu: 'interactionQueueConfig',
    componentMenu: InteractionQueueConfigComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/NewInteractionQueueConfiguration.aspx',
    routeMenu: 'customInteractionQueueConfig',
    componentMenu: CustomInteractionQueueConfigListComponent,
    title: 'Lista de Filas',
    linkType: LinkType.fromNavMenu
  },
  {
    routeMenu: 'configCustomQueue',
    title: 'Editar informações da fila',
    linkType: LinkType.fromPage
  },
  {
    routeMenu: 'newConfigCustomQueue',
    title: 'Nova fila',
    linkType: LinkType.fromPage
  },
  {
    urlMenu: '/Configuration/GlobalVariables/GlobalVariables.aspx',
    routeMenu: 'globalVariables',
    title: 'Variáveis Globais',
    componentMenu: GlobalVariablesComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Drivers/DriverUpdate.aspx',
    routeMenu: 'driverUpdateList',
    title: 'Atualização de Drivers',
    componentMenu: DriverUpdateListComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/GlobalVariables/GlobalVariableGroups.aspx',
    routeMenu: 'globalVariablesGroups',
    title: 'Grupos de variáveis globais',
    componentMenu: GlobalVariableGroupsComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/Metadata/Metadata.aspx',
    routeMenu: 'metadataStructureList',
    title: 'Estrutura de Metadados',
    componentMenu: MetadataStructureListComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/Metadata/UserMetadataAdmin.aspx',
    routeMenu: 'userMetadataAdmin',
    title: 'Metadados de Usuários',
    componentMenu: UserMetadataAdminComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/Distribution/CustomInteractionDistribution.aspx',
    routeMenu: 'customInteractionDistribution',
    title: 'Regras de distribuição',
    componentMenu: DistributionCustomInteractionComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/Pools/Pools.aspx',
    routeMenu: 'pools',
    title: 'Lista de Pools',
    componentMenu: PoolsComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/SystemFlow/SystemFlow.aspx',
    routeMenu: 'systemFlow',
    componentMenu: SystemFlowComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Runtime/BusinessProcessQueueManager.aspx',
    routeMenu: 'businessProcessQueueManager',
    componentMenu: BusinessProcessQueueManagerComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Batch/BatchManagement.aspx',
    routeMenu: 'batchManager',
    title: 'Administração de Lote',
    componentMenu: BatchManagementComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/Batch/BatchTemplatesConfiguration.aspx',
    routeMenu: 'batchTemplateList',
    title: 'Layouts de Lote',
    componentMenu: TemplateConfigurationComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/DataExtraction/DataExtractionFileLayoutList.aspx',
    routeMenu: 'dataExtractionFileLayoutList',
    title: 'Layouts de Extração',
    componentMenu: DataExtractionLayoutComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/Configuration/Scheduling/Scheduling.aspx',
    routeMenu: 'scheduling',
    title: 'Agendamentos',
    componentMenu: SchedulingComponent,
    linkType: LinkType.fromNavMenu
  },
  {
    urlMenu: '/TaskMonitoring/TaskMonitoring.aspx',
    routeMenu: 'taskMonitoring',
    title: 'Acompanhamento de Extração',
    componentMenu: TaskMonitoringComponent,
    linkType: LinkType.fromNavMenu
  }
];

export interface MenuModelFromTo {
  urlMenu?: string;
  routeMenu?: string;
  componentMenu?: Type<any>;
  title?: string;
  linkType?: LinkType;
}

